export default __webpack_public_path__ + "static/media/chat-46.06790686.svg";